import { apiClient } from "../apiClient";
import { IQueueStatus } from "../../model/respone/queue/IQueueStatus";

export const queueApi = {
    GetStatus: () => apiClient.get<IQueueStatus>("queue/status"),
};
